import React, { useContext, useEffect } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useQualityService from '../../../app/services/hooks/useQualityService';

interface Props {
    qualityId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const QualitySwitchChange = ({ qualityId, checkValue, callbackSuccess }: Props) => {
    const { hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);
    const { activeQuality } = useQualityService();

    useEffect(() => {
        setChecked(checkValue);
    }, [checkValue]);

    const active = (value: boolean) => {
        setChecked(value);
        activeQuality(qualityId, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={qualityId} callback={active} />;
};

export default QualitySwitchChange;
